import React from 'react'

import FormDrawerWrapper from '../../../../../../features/components/FormDrawerWrapper'
import ShortPostRightCreateForm from './ShortPostRightCreateForm'

import { POST_RIGHT_CREATE } from '../../../../../../constants/forms'

const ShortPostRightCreate = ({ openBtnClassName }) => {
  return (
    <FormDrawerWrapper
      formName={POST_RIGHT_CREATE}
      title="Create a new social post report"
      openButtonText="Create organic social report"
      openBtnClassName={openBtnClassName}
    >
      <ShortPostRightCreateForm />
    </FormDrawerWrapper>
  )
}

export default ShortPostRightCreate
